import { useDispatch, useSelector } from "react-redux";
import { downloadWeightedPriceReport } from "../thunks/downloadReport";
import React from "react";
import { StoreType } from "../../../../../core/store/reducers";
import { FetchStateType } from "../../../../models";

export const useWeightedPriceDownloader = () => {
  const fetchState = useSelector<StoreType, FetchStateType>(
    (s) => s.data.reports.exchbusiness.weightedPrice.downloadReportFetchState
  );
  const dispatch = useDispatch();
  const download = React.useCallback(
    () => dispatch(downloadWeightedPriceReport()),
    [dispatch]
  );

  return [download, fetchState] as [typeof download, typeof fetchState];
};
